import {Button, Input, Spin} from 'antd'
import classNames from 'classnames'
import FieldsFactory from 'components/form/FieldsFactory'
import {SubmitButton} from 'components/form/FormActionBar'
import Pure from 'components/Pure'
import {Formik} from 'formik'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo} from 'react'
import {createControlledFormField} from 'views/AppLocals/factory/createFormField'
import LoadingPage from 'views/LoadingPage'
import {NullAsDefault} from 'views/Shared'
import ErrorReportContext from '../ErrorReportContext'
import {renderReportStatus} from '../functions/renderReportStatus'
import {ReportCreator} from './ErrorReportMeta'
import {BibleBookFillSvg} from "../../../components/Svgs/BibleBookSvg";

const formSchema = {
  title: {
    title: 'title',
    children: [
      {
        name: 'title',
        component: createControlledFormField({
          readOnly: true,
          disabled: true,
          className: 'w-full',
          placeholder: 'title',
        }),
      },
    ],
  },
  description: {
    title: 'description',
    children: [
      {
        name: 'description',
        component: createControlledFormField({
          rows: 3,
          readOnly: true,
          disabled: true,
          className: 'w-full',
          placeholder: 'description',
          Component: Input.TextArea,
        }),
      },
    ],
  },
  notes: {
    title: 'notes',
    children: [
      {
        name: 'notes',
        component: createControlledFormField({
          rows: 3,
          className: 'w-full',
          placeholder: 'notes',
          Component: Input.TextArea,
        }),
      },
    ],
  },
  creator_status: {
    inline: true,
    className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
    itemClassNames: ['col-span-1 md:col-span-2', 'col-span-1 justify-end'],
    children: [
      {
        label: 'creator',
        name: 'creator',
        component: ({ value }) => (
            <Pure input={[value]}>
              <ReportCreator creator={value} className="ml-3"/>
            </Pure>
        ),
      },
      {
        label: 'status',
        name: 'status',
        component: ({ value }) => (
            <Pure input={[value]}>
              {renderReportStatus(value)}
            </Pure>
        ),
      },
    ],
  },
  // status: {
  //   title: 'status',
  //   children: [
  //     {
  //       name: 'status',
  //       component: ({ value }) => (
  //           <Pure input={[value]}>
  //             <div className="flex items-end">
  //               {renderReportStatus(value)}
  //             </div>
  //           </Pure>
  //       ),
  //     },
  //   ],
  // },
}

const ApproveReportModal = ({
  item,
  onCancel,
  header = null,
  onSubmit = NullAsDefault,
  isLoading = false,
  submitText = 'approve',
  type,
  ...props
}) => {
  const t = useTranslate()

  const { spinning } = useContext(ErrorReportContext)

  const initialValues = useMemo(
    () => ({
      note: undefined,
      ...item,
    }),
    [item]
  )

  let iconColor, text_color, border_color

  switch (type) {
    case 'approve':
      iconColor = 'text-green-300'
      text_color = 'text-green-600'
      border_color = 'border-green-300'
      break
    case 'reject':
      iconColor = 'text-orange-300'
      text_color = 'text-orange-500'
      border_color = 'border-orange-200'
      break
    default:
      return null
  }

  const handleSubmit = (values) => {
    onSubmit(_.omitBy(values, _.isUndefined))
  }

  const validate = (values) => {
    let errors = {}

    const { notes } = values ?? {}

    if (_.isEmpty(notes)) {
      errors.notes = t('required field')
    }

    return errors
  }

  if (!!isLoading) {
    return <LoadingPage />
  }

  return (
    <div className="flex flex-col gap-2">
      {header}
      <Spin spinning={!!spinning}>
        <Formik
          validate={validate}
          onSubmit={handleSubmit}
          validateOnMount={true}
          validateOnChange={true}
          enableReinitialize={true}
          initialValues={initialValues}>
          <div className="flex flex-col gap-3">
            <div className={classNames('p-2 flex items-center gap-2 border rounded-lg mb-2', border_color)}>
              <BibleBookFillSvg size={28} className={text_color}/>
              <span style={{ fontSize: '1rem' }} className={classNames('font-bold', text_color)}>
                {_.get(item, 'owner.title')}
              </span>
            </div>
            <FieldsFactory
              formSchema={[
                formSchema.title,
                formSchema.creator_status,
                formSchema.description,
                formSchema.notes,
              ]}
            />
            <div className="flex flex-1 gap-2 justify-end">
              <Button
                className="button-rounded-lg no-border text-color-400"
                onClick={onCancel}>
                {t('cancel')}
              </Button>
              <SubmitButton
                shape="round"
                label={submitText}
                dirtyRequired={false}
              />
            </div>
          </div>
        </Formik>
      </Spin>
    </div>
  )
}

export default ApproveReportModal
